/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ExportJobStatusSchemaStatus } from './exportJobStatusSchemaStatus';

export interface ExportJobStatusSchema {
  job_id: string;
  status: ExportJobStatusSchemaStatus;
  download_url?: string | null;
  profile_count?: number | null;
  error?: string | null;
}
